import React from 'react';
import ReactDOM from 'react-dom';

interface DialogModalProps {
  isOpen: boolean;
  type: 'error' | 'confirm';
  title: string;
  message: string | React.ReactNode;
  id?: number | string;
  onClose: () => void;
  onConfirm?: (id?: number | string) => void;
}

const DialogModal: React.FC<DialogModalProps> = ({
                                                   isOpen,
                                                   type,
                                                   title,
                                                   message,
                                                   id,
                                                   onClose,
                                                   onConfirm,
                                                 }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      {/* Затемнение фона */}
      <div className="modal-backdrop show"></div>

      {/* Модалка по центру */}
      <div
        className="modal d-block"
        tabIndex={-1}
        role="dialog"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <p>{message}</p>
              {/*{id !== undefined && (*/}
              {/*  <small className="text-muted">ID: {id}</small>*/}
              {/*)}*/}
            </div>
            <div className="modal-footer">
              {type === 'confirm' && (
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                >
                  Cancel
                </button>
              )}
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  onConfirm?.(id);
                  onClose();
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default DialogModal;
